<script>
    import {_} from '../lib/i18n';
    export let params;
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    import {navigate} from "svelte-routing";

    function gotoTariffs() {
        navigate(`${path}/dashboard/subscription`);
    }

</script>

<div class="data-hidden-alert" >
    <p class="data-hidden-alert__title">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="9.99935" cy="14.1663" rx="0.833333" ry="0.833333" fill="#161516"/>
            <path d="M10 8.33301L10 11.6663" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.11323 14.6052L8.21049 4.41072C8.94754 2.93662 11.0512 2.93662 11.7882 4.41071L16.8855 14.6052C17.5504 15.935 16.5834 17.4997 15.0966 17.4997H4.90208C3.41532 17.4997 2.44833 15.9351 3.11323 14.6052Z" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{$_('freeAccessDataHiddenAlert.title')}
    </p>
    <p class="data-hidden-alert__body">
        {$_('freeAccessDataHiddenAlert.description')}
    </p>
    <button on:click={gotoTariffs}  class="button data-hidden-alert__btn">
        {$_('freeAccessDataHiddenAlert.selectPlanBtnLabel')}
    </button>
</div>

<style>
    .data-hidden-alert {
        display: flex;
        padding: 12px 16px;
        margin-top: 15px;
        margin-bottom: 15px;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        border-radius: 6px;
        background: #FEFFC8;
    }
    .data-hidden-alert__title {
        font-weight: 700;
    }
    .data-hidden-alert__title > svg {
        position: absolute;
    }
    .data-hidden-alert__body {
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
    }
    .data-hidden-alert__btn {
        background: none;
        color: #000000;
        border: 1px solid #000000;
    }
</style>